import TaskStatus from '@/enums/TaskStatus';

export default class TaskStatusHelpers {
  static getIcon = (status: TaskStatus): string => {
    switch (status) {
      case TaskStatus.WAITING:
        return 'mdi-clock-outline';
      case TaskStatus.IN_PROGRESS:
        return 'mdi-cog';
      case TaskStatus.SUCCESS:
        return 'mdi-check-circle';
      case TaskStatus.ERROR:
        return 'mdi-alert-circle';
      case TaskStatus.WARNING:
        return 'mdi-alert-octagon';
      default:
        return 'mdi-help-circle';
    }
  };

  static getIconColor = (status: TaskStatus): string => {
    switch (status) {
      case TaskStatus.WAITING:
        return 'grey';
      case TaskStatus.IN_PROGRESS:
        return 'blue';
      case TaskStatus.SUCCESS:
        return 'green';
      case TaskStatus.WARNING:
        return 'orange';
      case TaskStatus.ERROR:
        return 'red';
      default:
        return 'grey';
    }
  };
}
